// extracted by mini-css-extract-plugin
export default {"root":"XGZm1","icon":"pwmN6","dropdown":"R904q"};